// extracted by mini-css-extract-plugin
module.exports = {"main-region":"_1410bfd27b--main-region--YXzUK","clickable-text":"_1410bfd27b--clickable-text--MhO5a"};